export function common() {
  
  //////ページトップ
  $(function () {
    var topBtn = $('#page-top');
    topBtn.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 650) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    topBtn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 1000);
      return false;
    });
  });
  //////スムーススクロール
  $(function () {
    $('a[href^="#"]').click(function () {
      var speed = 1500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
  });

  //読み込み時にdata-functionをチェックし、タグに色クラスを設定にする。
  $(document).ready(function() {
    $('.list_item').each(function() {
      var $listItem = $(this);
      var functionsData = $listItem.data('function'); // data-function配列取得
  
      $listItem.find('.list_item_function span').each(function() {
        var $span = $(this);
        var text = $span.text().trim();
  
        switch(text) {
          case '高度急性期':
            if(functionsData.includes('高度急性期')) {
              $span.addClass('clr_bblu');
            } else {
              $span.removeClass('clr_bblu');
            }
            break;
          case '急性期':
            if(functionsData.includes('急性期')) {
              $span.addClass('clr_blu');
            } else {
              $span.removeClass('clr_blu');
            }
            break;
          case '回復期':
            if(functionsData.includes('回復期')) {
              $span.addClass('clr_grn');
            } else {
              $span.removeClass('clr_grn');
            }
            break;
          case '慢性期':
            if(functionsData.includes('慢性期')) {
              $span.addClass('clr_org');
            } else {
              $span.removeClass('clr_org');
            }
            break;
          case '地域包括ケア':
            if(functionsData.includes('地域包括ケア')) {
              $span.addClass('clr_yel');
            } else {
              $span.removeClass('clr_yel');
            }
            break;
        }
      });
    });
  });


  //////checkbox
  var searchBox = '.search_item_fx'; // 絞り込む項目を選択するエリア
  var listItem = '.list_item'; // 絞り込み対象のアイテム
  var hideClass = 'is_hide'; // 絞り込み対象外の場合に付与されるclass名
  $(function () {
    $(document).on('change', searchBox + ' input', function () {
      search_filter();
    });
  });

  function search_filter() {
    $(listItem).removeClass(hideClass);
    for (var i = 0; i < $(searchBox).length; i++) {
      var name = $(searchBox).eq(i).find('input').attr('name');
      var searchData = get_selected_input_items(name);
      if(searchData.length === 0 || searchData[0] === '') {
        continue;
      }
      for (var j = 0; j < $(listItem).length; j++) {
        var itemData = get_setting_values_in_item($(listItem).eq(j), name);
        var check = array_match_check(itemData, searchData);
        if(!check) {
          $(listItem).eq(j).addClass(hideClass);
        }
      }
    }
  }

  function get_selected_input_items(name) {
    var searchData = [];
    $('[name=' + name + ']:checked').each(function() {
      searchData.push($(this).val());
    });
    return searchData;
  }
  function get_setting_values_in_item(target, data) {
    var itemData = target.data(data);
    if(!Array.isArray(itemData)) {
      itemData = [itemData];
    }
    return itemData;
  }
  function array_match_check(arr1, arr2) {
    // 絞り込み対象かどうかを調べる
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if(arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }
  //エリアで絞る
  $(function(){
    $('.search_area .search_item_rt input[type="checkbox"]').change(function(){
      var cnt1 = $('.search_area .search_item_rt input[type="checkbox"]:checked').length;
          if(cnt1 == 0) {
            $("#check01").prop('checked',true);
          } else {
            $("#check01").prop('checked',false);
          }
      });
    $("#check01").change(function() {
      if ($("#check01").prop('checked')) {
        $('.search_area .search_item_rt input[type="checkbox"]').prop('checked', false);
      } else {
        $('.search_area .search_item_lt input[type="checkbox"]').prop('checked', true);
      }
    });
  });
  //機能で絞る
  $(function(){
    $('.search_function .search_item_rt input[type="checkbox"]').change(function(){
      var cnt1 = $('.search_function .search_item_rt input[type="checkbox"]:checked').length;
          if(cnt1 == 0) {
            $("#check10").prop('checked',true);
          } else {
            $("#check10").prop('checked',false);
          }
      });
    $("#check10").change(function() {
      if ($("#check10").prop('checked')) {
        $('.search_function .search_item_rt input[type="checkbox"]').prop('checked', false);
      } else {
        $('.search_function .search_item_lt input[type="checkbox"]').prop('checked', true);
      }
    });
  });

}